import { Button, Tooltip, Typography } from "@mui/material";
import useRouteHelper from "../../../../../shared/routes/useRouteHelper.hook";
import useAppStoreContext from "../../../../../shared/context/app-store/app-store.context";

export default function ReportNameCellRenderer(props: any) {

  const { gotoReportDataPage } = useRouteHelper();
  const { selectReportByReportCode } = useAppStoreContext();

  const handleNavigate = () => {
    selectReportByReportCode(props.data.reportCode);
    setTimeout(() => {
      gotoReportDataPage();
    }, 300);
  }


  return (<>
    <Tooltip title={props.data?.ReportDescription} enterDelay={1000}>
      <Button sx={{ textTransform: 'none' }} style={{ paddingLeft: 0, margin: 0, display: "block", textAlign: "left" }} onClick={handleNavigate}>
        <Typography variant="body1" sx={{ fontWeight: '500', textDecoration: 'underline', color: (x) => x.palette.primary.main }}>{props.value}</Typography>
        {/* <Typography variant="body2" sx={{
          pb: 1, fontWeight: '500', color: 'text.secondary',
          overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: "2", WebkitBoxOrient: "vertical",
        }}> {props.data?.ReportDescription}</Typography> */}
      </Button>
    </Tooltip>

  </>);
}